/**
 * Reusable surface treatments — colour, border, radius and elevation only.
 * Padding stays with the component so one surface can be used at several
 * densities without forking the style.
 */
export const layerStyles = {
  /** Standard content surface. Resting elevation, no float. */
  card: {
    value: {
      bg: 'card.bg',
      borderWidth: '1px',
      borderColor: 'card.border',
      borderRadius: 'lg',
      boxShadow: 'xs',
    },
  },
  /** Same shape without elevation, for surfaces that sit in a grid. */
  panel: {
    value: {
      bg: 'card.bg',
      borderWidth: '1px',
      borderColor: 'card.border',
      borderRadius: 'lg',
    },
  },
  /**
   * Highlighted card for genuinely branded content — an amber wash, never a
   * top border or a coloured card for variety's sake.
   */
  cardBrand: {
    value: {
      bg: 'brand.subtle',
      borderWidth: '1px',
      borderColor: 'brand.border',
      borderRadius: 'lg',
    },
  },
  /** Flat region inside a card for supporting detail. Never a nested card. */
  inset: {
    value: {
      bg: 'surface.subtle',
      borderRadius: 'md',
    },
  },
  tableContainer: {
    value: {
      bg: 'card.bg',
      borderWidth: '1px',
      borderColor: 'card.border',
      borderRadius: 'lg',
      overflow: 'hidden',
    },
  },
  /** Floating surfaces: menus and popovers. */
  menuSurface: {
    value: {
      bg: 'surface.raised',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'md',
      boxShadow: 'md',
    },
  },
  /** Modal surfaces take the larger radius and the deepest shadow. */
  dialogSurface: {
    value: {
      bg: 'surface.raised',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'xl',
      boxShadow: 'lg',
    },
  },
}
